// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"806":"16861afe60e131d4","886":"296d1fe3af8aaf35"}[chunkId] + ".js";
};